import { CSSProperties, ReactNode } from "react";
import css from "./grid-column.module.scss";

interface IGridColumnProps {
  children: ReactNode;
  center?: boolean;
  className?: string;
  style?: CSSProperties;

  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  xxl?: number;
}

const GridColumn = (props: IGridColumnProps) => {
  const { className, children, center, style, xs, sm, md, lg, xl, xxl } = props;

  const columnClasses = [
    xs ? `col-xs-${xs}` : "col-xs-4",
    sm ? `col-sm-${sm}` : "col-sm-6",
    md ? `col-md-${md}` : "col-md-8",
    lg ? `col-lg-${lg}` : "col-lg-12",
    xl ? `col-xl-${xl}` : "",
    xxl ? `col-xxl-${xxl}` : "",
    center ? css.center : "",
  ].join(" ");

  return (
    <div className={`${css.gridColumn} ${className} ${columnClasses}`} style={style}>
      {children}
    </div>
  );
};

export default GridColumn;
